import React, { useState } from "react";
import { Link } from "react-router-dom";
import PlayProcess from "./playProcess";
import CustomModal from "../../UtilityComponents/customModal";
import { getWorkers } from "../../Redux/actions/workers";
import { deleteProcess } from "../../Redux/actions/processes";
import SamplePayload from "./samplePayload";
import  DeleteProcess from "./deleteProcess.js";
import curly from "../../Assets/curly_brackets.png";
import { addNotification } from "../../Utilities/notifications";
import LoadProfile from "../../UtilityComponents/loadProfile";

function ProcessCard(props){

  let { bot, match, history, offSet, getUpdateData} = props;
   
  const [modal, setModal] = useState(false);
  const [payloadModal, setPayloadModal] = useState(false);
  const [deleteModal,setDeleteModal] = useState(false);
  const [workers, setWorkers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [delLoading,setDelLoading] =useState(false)

  const toggle = (obj) => setModal(!modal)
    
  const payloadToggle = () => setPayloadModal(!payloadModal)

   const deleteModaltoggle = () => {
      setDeleteModal(!deleteModal)
   }

   const handlePlay = async () => {
     setLoading(true);
     let data = await getWorkers();
     setLoading(false);
      if(data && data.length > 0){
        setWorkers(data);
        setModal(true);
      } else{
       addNotification({
         title: "Techforce.ai",
         message: "Seems like you haven't created any worker, Please create a worker and try to play",
         type: "info",
         container : "top-center"
       });
        setTimeout(() => {
          history.push("/workers");
        }, 2000);
      }
   }

   const handlePayload = async () => {
    let data = await getWorkers();
     if(data && data.length > 0){
       setWorkers(data);
       setPayloadModal(true);
     } else{
      addNotification({
        title: "Techforce.ai",
        message: "Seems like you haven't created any worker, Please create a worker and try to play",
        type: "info",
        container : "top-center"
      });
       setTimeout(() => {
         history.push("/workers");
       }, 2000);
     }
  }


   const handleDelete = async () =>{
      let { id } = bot
      if(id){
        deleteModaltoggle()
        setDelLoading(true)
        let status= await deleteProcess(bot.id) 
        setDelLoading(false)
        if(status === 200){	
          getUpdateData(offSet)
        }
      }else{
      
      }
   }
   
    return (
      <div className="process-card">
        <div className="flow-icons">
          {loading ? <i className="fas fa-circle-notch fa-spin play"></i> : 
                     <i onClick={handlePlay} className="fas fa-play-circle play"></i> }
                     <div className="rounded" onClick={handlePayload}>
                       <img src = {curly} alt="process icon" width="20" className="play" style={{margin:"7px 8px"}}></img>
                    </div>
        </div>
        <div className="flow-name">
          <div>{bot.name} (V - {bot["TF_BOT_VERSION.version_number"]})</div>
        </div>
        <div className="flow-info">
          <div>
            <label className="label-name">Versions</label>
            <Link to={`${match.url}/${bot.name}/versions`}>
              {bot.versions_count}
            </Link>
            {/* <label className="label-value">5</label> */}
          </div>
          <div>
            <label className="label-name">Instances</label>
            {/* <label className="label-value" onClick={() => history.push(`${bot.TF_FLOW_NAME}/instances`) }>
                {bot.instancesCount}
            </label> */}
            <Link to={`${match.url}/${bot.name}/instances`}>{bot.instances_count}</Link>
          </div>
          <div >
            <label className="label-name">Id</label>
          <label className="label-value">
              {bot["TF_BOT_VERSION.bot_id"]}
            </label>
            </div>
          <div>
            <label className="label-name" style={{whiteSpace:"nowrap"}}>Created Date</label>
            <label className="label-value">
              {bot["TF_BOT_VERSION.created_at"].split("T")[0]}
            </label>
          </div>
        </div>
        <div className="flow-user">
          <LoadProfile {...bot} />
          <div className="flow-email">
            {bot["TF_BOT_VERSION.email"]}
          </div>
          {delLoading ? <i
            style={{ color: "#02ce9d",marginLeft:"-12px"}}
            className="fas fa-circle-notch fa-spin"
           ></i> : 
           <i  style={{ color: "#02ce9d",cursor:"pointer",paddingTop:"5px",marginLeft:"-12px"}}
            className="fas fa-trash-alt" data-toggle="tooltip" data-placement="top" title="Delete"
            onClick={()=>deleteModaltoggle()}>
           </i>
          }
        </div>
        <div>
          {deleteModal ? <CustomModal comp={<DeleteProcess handleDelete={() => handleDelete()} name={bot.name} toggle={() => deleteModaltoggle()}/>} 
                name={`Are you sure you want to delete Action Flow `}
                toggle={() => deleteModaltoggle()}
                modal={deleteModal} /> : null } 
        </div>
        <div>
          {payloadModal ? <CustomModal comp={<SamplePayload  workers={workers.length>0?workers[0].worker_id:""}  bot={bot} toggle={() => payloadToggle()}/>} 
                name={`Payload to trigger the action flow via API Call `}
                toggle={() => payloadToggle()}
                modal={payloadModal} /> : null } 
        </div>
        {modal ? (
          <CustomModal
            comp={
              <PlayProcess 
                workers={workers}
                offSet={offSet}
                getUpdateData={getUpdateData}
                bot={bot}
                toggle={() => toggle()}
              />
            }
            name={bot.name}
            toggle={() => toggle()}
            modal={modal}
          />
        ) : null}
      </div>
    );
}

export default ProcessCard;